import * as React from 'react';

import { useIsOverflow } from '../../../hooks/useIsOverflow';
import ZIndexLayers from '../../../services/ZIndexLayers';
import TextTooltip from '../../TextTooltip';
import {
  FilterChipActions,
  FilterChipContainer,
  FilterChipIcon,
  FilterChipSpacer,
  FilterChipText,
  StyledCloseIcon,
} from './FilterChip.styles';

interface FilterChipProps {
  icon: React.ReactNode;
  text: string;
  onClose: () => void;
}

const FilterChip = ({ icon, text, onClose }: FilterChipProps) => {
  const ref = React.useRef(null);
  const isOverflow = useIsOverflow(ref);

  return (
    <FilterChipContainer>
      <FilterChipIcon>{icon}</FilterChipIcon>
      <TextTooltip tooltipText={text} $zIndex={ZIndexLayers.tooltip} isDisabled={!isOverflow} offset={16}>
        <FilterChipText ref={ref}>{text}</FilterChipText>
      </TextTooltip>
      <FilterChipSpacer></FilterChipSpacer>
      <FilterChipActions>
        <StyledCloseIcon onClick={onClose}></StyledCloseIcon>
      </FilterChipActions>
    </FilterChipContainer>
  );
};

export default FilterChip;
